import React from 'react'
import Card from '../../core/Card'
import { reduxForm, submit } from 'redux-form'
import { connect } from 'react-redux'
// import { message } from 'antd';
import onMount from '../../core/onMount'
import { createVehicle } from './actions'
// LOCAL
import Vehicle from './Vehicle'

const mapStateToProps = (state, ownProps) => {
  return {
    buttonTitle: 'Save',
    title: 'New Vehicle'
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemoteSubmit: ()=> dispatch(submit('newVehicle'))
  }
}
// const Mounted = onMount(({dispatch}) => dispatch({type: 'NEW_VEHICLE_DID_MOUNT'}) )(Vehicle)

// const New = reduxForm({form: 'newVehicle', onSubmit})(Mounted)
const New = reduxForm({
  form: 'newVehicle',
  onSubmit: (values, dispatch)=> dispatch(createVehicle(values))
})(Vehicle)

export default connect(mapStateToProps, mapDispatchToProps)(New)



// WEBPACK FOOTER //
// ./src/account/vehicles/New.js